import React from 'react';
import { Link } from 'react-router-dom';

const MyLearning = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <Link to="/services/skills" className="text-teal-600 hover:text-teal-700 mb-4 inline-block font-medium transition-colors">
          ← Back to Skills Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">My Learning</h1>
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <p className="text-gray-600">Track your progress across all enrolled courses</p>
          <p className="text-sm text-gray-500 mt-4">Coming soon: Detailed course progress tracking</p>
        </div>
      </div>
    </div>
  );
};

export default MyLearning;
